/* Odds Comfort: collection and search filtering. One slim bar: department tabs, facet popovers with live counts, sort, grid size.
   Works client-side over the cards already on the page (the whole catalog fits one page), and keeps the URL shareable. */
(function () {
  'use strict';
  var Odds = window.Odds; if (!Odds) return;
  var $ = Odds.$, $$ = Odds.$$;

  var CUTS = ['crew', 'quarter', 'ankle', 'noshow'];
  var PACKS = ['3', '5', '6'];
  var FAMS = ['black', 'white', 'grey', 'navy', 'colourful'];
  var FAMCOL = { black: '#1b1b1b', white: '#f5f5f5', grey: '#b5b5b5', navy: '#23315e', colourful: 'conic-gradient(#e8232a,#f39a1e,#2bb0a0,#7a3a8f,#e8232a)' };
  var PTS = ['patterned', 'plain'];
  var SIZES = ['26-29', '30-33', '34-37', '38-41', '42-45'];
  var CUTHEIGHT = { crew: 92, quarter: 62, ankle: 38, noshow: 16 };
  var CHECK = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  function init(root) {
    if (!root || root.__facets) return; root.__facets = true;
    var grid = $('[data-grid]', root), cards = $$('.card', grid);
    if (!cards.length) return;
    var showDepts = root.hasAttribute('data-depts');
    var S = { dept: 'all', cut: [], pack: [], size: [], fam: [], pt: [], sort: 'featured', view: root.getAttribute('data-view') || '4' };
    var bar = $('[data-facet-bar]', root), pop = $('[data-facet-pop]', root), scrim = $('[data-facet-scrim]', root);
    var countEl = $('[data-facet-count]', root), emptyEl = $('[data-facet-empty]', root);
    var open = null;

    var data = cards.map(function (c, i) {
      return { el: c, dept: c.getAttribute('data-dept'), cut: c.getAttribute('data-cut'), packs: (c.getAttribute('data-packs') || '').split(' ').filter(Boolean), fam: (c.getAttribute('data-fam') || '').split(' ').filter(Boolean), size: (c.getAttribute('data-sizes') || '').split(' ').filter(Boolean), pt: c.getAttribute('data-pattern'), price: Number(c.getAttribute('data-price')) || 0, title: c.getAttribute('data-title') || '', created: Number(c.getAttribute('data-created')) || 0, rank: i };
    });

    /* ---- state <-> URL ---- */
    (function readURL() {
      var q = new URLSearchParams(location.search);
      ['cut', 'pack', 'size', 'fam', 'pt'].forEach(function (k) { if (q.get(k)) S[k] = q.get(k).split(',').filter(Boolean); });
      if (q.get('dept')) S.dept = q.get('dept');
      if (q.get('sort')) S.sort = q.get('sort');
      if (q.get('view')) S.view = q.get('view');
    })();
    function writeURL() {
      var q = new URLSearchParams(location.search);
      ['cut', 'pack', 'size', 'fam', 'pt'].forEach(function (k) { if (S[k].length) q.set(k, S[k].join(',')); else q.delete(k); });
      if (S.dept !== 'all') q.set('dept', S.dept); else q.delete('dept');
      if (S.sort !== 'featured') q.set('sort', S.sort); else q.delete('sort');
      var s = q.toString();
      try { history.replaceState({}, '', location.pathname + (s ? '?' + s : '')); } catch (e) { /* ignore */ }
    }

    function match(d, skip) {
      if (skip !== 'dept' && S.dept !== 'all' && d.dept !== S.dept) return false;
      if (skip !== 'cut' && S.cut.length && S.cut.indexOf(d.cut) < 0) return false;
      if (skip !== 'pack' && S.pack.length && !d.packs.some(function (p) { return S.pack.indexOf(p) > -1; })) return false;
      if (skip !== 'size' && S.size.length && !d.size.some(function (z) { return S.size.indexOf(z) > -1; })) return false;
      if (skip !== 'fam' && S.fam.length && !d.fam.some(function (f) { return S.fam.indexOf(f) > -1; })) return false;
      if (skip !== 'pt' && S.pt.length && S.pt.indexOf(d.pt) < 0) return false;
      return true;
    }
    function has(d, f, v) { return f === 'cut' ? d.cut === v : f === 'pack' ? d.packs.indexOf(v) > -1 : f === 'size' ? d.size.indexOf(v) > -1 : f === 'fam' ? d.fam.indexOf(v) > -1 : d.pt === v; }
    function optCount(f, v) { return data.filter(function (d) { return match(d, f) && has(d, f, v); }).length; }
    var label = {
      cut: function (v) { return Odds.t('cut_' + v); },
      pack: function (v) { return Odds.plural('pairs', Number(v)); },
      size: function (v) { return Odds.t('size_value', { v: v.replace('-', '–') }); },
      fam: function (v) { return Odds.t('fam_' + v); },
      pt: function (v) { return Odds.t('collection_' + v); }
    };
    var facetTitle = { cut: 'collection_cut', pack: 'collection_pack', size: 'collection_size', fam: 'collection_colour', pt: 'collection_pattern' };
    var options = { cut: CUTS, pack: PACKS, size: SIZES, fam: FAMS, pt: PTS };
    // only offer facets that vary within this collection
    var avail = { cut: CUTS.filter(function (c) { return data.some(function (d) { return d.cut === c; }); }), pack: PACKS.filter(function (p) { return data.some(function (d) { return d.packs.indexOf(p) > -1; }); }), size: SIZES.filter(function (z) { return data.some(function (d) { return d.size.indexOf(z) > -1; }); }), fam: FAMS.filter(function (f) { return data.some(function (d) { return d.fam.indexOf(f) > -1; }); }), pt: PTS.filter(function (p) { return data.some(function (d) { return d.pt === p; }); }) };

    /* ---- toolbar ---- */
    function renderBar() {
      var html = '';
      if (showDepts) {
        html += '<div class="tabs"><div class="tablist" role="tablist">' + ['all', 'men', 'women', 'kids'].map(function (w) {
          var n = data.filter(function (d) { return match(d, 'dept') && (w === 'all' || d.dept === w); }).length;
          return '<button type="button" role="tab" data-dept="' + w + '" aria-selected="' + (S.dept === w) + '">' + Odds.t('dept_' + w) + '<sup>' + n + '</sup></button>';
        }).join('') + '</div><i class="ink" data-ink></i></div>';
      }
      html += '<div class="facets">';
      Object.keys(options).forEach(function (f) {
        if (avail[f].length < 2) return;
        var sel = S[f], val = '';
        if (f === 'fam' && sel.length) val = '<span class="dots">' + sel.map(function (v) { return '<i style="background:' + FAMCOL[v] + '"></i>'; }).join('') + '</span>';
        else if (sel.length) val = '<span class="val">' + Odds.esc(label[f](sel[0])) + (sel.length > 1 ? ' +' + (sel.length - 1) : '') + '</span>';
        html += '<button type="button" class="facet' + (sel.length ? ' on' : '') + '" data-facet="' + f + '" aria-haspopup="dialog" aria-expanded="' + (open === f) + '"><span>' + Odds.t(facetTitle[f]) + '</span>' + val + '<svg class="icon" aria-hidden="true"><use href="#i-down"/></svg></button>';
      });
      var any = S.cut.length + S.pack.length + S.size.length + S.fam.length + S.pt.length;
      if (any) html += '<button type="button" class="clearf" data-clear-all>' + Odds.t('collection_clear_all') + '</button>';
      html += '<button type="button" class="facet sort" data-facet="sort" aria-haspopup="dialog" aria-expanded="' + (open === 'sort') + '"><span>' + Odds.t('collection_sort') + ':</span><span class="val">' + Odds.t('sort_' + S.sort) + '</span><svg class="icon" aria-hidden="true"><use href="#i-down"/></svg></button></div>';
      html += '<div class="tb-end"><span class="count num" aria-live="polite" data-facet-count></span><div class="seg views" role="group"><button type="button" data-view="4" aria-pressed="' + (S.view === '4') + '" aria-label="' + Odds.t('collection_grid_dense') + '"><svg class="icon" aria-hidden="true" viewBox="0 0 16 16" style="width:16px;height:16px"><use href="#i-grid"/></svg></button><button type="button" data-view="3" aria-pressed="' + (S.view === '3') + '" aria-label="' + Odds.t('collection_grid_large') + '"><svg class="icon" aria-hidden="true" viewBox="0 0 16 16" style="width:16px;height:16px"><use href="#i-rows"/></svg></button></div></div>';
      bar.innerHTML = '<div class="tb">' + html + '</div>';
      countEl = $('[data-facet-count]', bar);
      placeInk(); renderPop();
    }
    function placeInk() {
      var ink = $('[data-ink]', bar), a = $('.tablist [aria-selected="true"]', bar); if (!ink || !a) return;
      var dist = Odds.rtl ? ink.parentNode.offsetWidth - a.offsetLeft - a.offsetWidth : a.offsetLeft;
      ink.style.width = a.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + (Odds.rtl ? -dist : dist) + 'px)';
    }

    function renderPop() {
      pop.classList.toggle('on', !!open); scrim.classList.toggle('on', !!open);
      if (!open) return;
      var body = '';
      if (open === 'sort') {
        body = '<h4>' + Odds.t('collection_sort') + '</h4>' + ['featured', 'price_asc', 'price_desc', 'title', 'newest'].map(function (s) {
          return '<button type="button" class="opt radio" data-sort="' + s + '" aria-pressed="' + (S.sort === s) + '"><span class="box"></span><span>' + Odds.t('sort_' + s) + '</span></button>';
        }).join('');
      } else {
        var f = open;
        body = '<h4>' + Odds.t(facetTitle[f]) + '</h4>';
        if (f === 'fam') {
          body += '<div class="cgrid">' + avail.fam.map(function (v) { var n = optCount(f, v), on = S.fam.indexOf(v) > -1; return '<button type="button" class="copt" data-val="' + v + '" aria-pressed="' + on + '"' + (n || on ? '' : ' disabled') + '><i style="background:' + FAMCOL[v] + '"></i>' + Odds.esc(label.fam(v)) + '<small>' + n + '</small></button>'; }).join('') + '</div>';
        } else {
          body += avail[f].map(function (v) {
            var n = optCount(f, v), on = S[f].indexOf(v) > -1;
            var lead = f === 'cut' ? '<span class="h"><i style="height:' + CUTHEIGHT[v] + '%"></i></span>' : '';
            return '<button type="button" class="opt" data-val="' + v + '" aria-pressed="' + on + '"' + (n || on ? '' : ' disabled') + '><span class="box">' + CHECK + '</span>' + lead + '<span>' + Odds.esc(label[f](v)) + '</span><span class="n num">' + n + '</span></button>';
          }).join('');
        }
        body += '<div class="pfoot"><button type="button" class="reset" data-reset="' + f + '"' + (S[f].length ? '' : ' disabled') + '>' + Odds.t('collection_clear') + '</button><button type="button" class="btn" data-done>' + Odds.plural('show_n', visibleCount()) + '</button></div>';
      }
      pop.innerHTML = body;
      placePop();
    }
    function placePop() {
      var b = $('[data-facet="' + open + '"]', bar); if (!b || !open) return;
      if (window.innerWidth < 700) { pop.style.left = ''; pop.style.top = ''; return; }
      var r = b.getBoundingClientRect(), w = pop.offsetWidth || 330;
      var x = Odds.rtl ? r.right - w : r.left; x = Math.max(12, Math.min(x, window.innerWidth - w - 12));
      pop.style.left = x + 'px'; pop.style.top = (r.bottom + 10) + 'px';
    }
    function visibleCount() { return data.filter(function (d) { return match(d); }).length; }

    /* ---- apply ---- */
    function apply(skipBar) {
      var vis = data.filter(function (d) { return match(d); });
      var by = {
        featured: function (a, b) { return a.rank - b.rank; },
        price_asc: function (a, b) { return a.price - b.price || a.rank - b.rank; },
        price_desc: function (a, b) { return b.price - a.price || a.rank - b.rank; },
        title: function (a, b) { return a.title.localeCompare(b.title, Odds.cfg.locale); },
        newest: function (a, b) { return b.created - a.created || a.rank - b.rank; }
      }[S.sort];
      var order = data.slice().sort(by);
      order.forEach(function (d) { grid.appendChild(d.el); d.el.hidden = !match(d); });
      grid.classList.toggle('big', S.view === '3');
      if (emptyEl) emptyEl.hidden = vis.length > 0;
      writeURL();
      if (!skipBar) renderBar();
      if (countEl) countEl.textContent = Odds.plural('styles', vis.length);
      Odds.emit('dom:updated');
    }

    /* ---- events ---- */
    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-dept]'); if (d && bar.contains(d)) { S.dept = d.getAttribute('data-dept'); apply(); return; }
      var fb = e.target.closest('[data-facet]'); if (fb && bar.contains(fb)) { open = open === fb.getAttribute('data-facet') ? null : fb.getAttribute('data-facet'); renderBar(); return; }
      var v = e.target.closest('[data-view]'); if (v && bar.contains(v)) { S.view = v.getAttribute('data-view'); apply(); return; }
      if (e.target.closest('[data-clear-all]') || e.target.closest('[data-reset-filters]')) { S.cut = []; S.pack = []; S.size = []; S.fam = []; S.pt = []; S.dept = root.hasAttribute('data-depts') ? 'all' : S.dept; open = null; apply(); return; }
      if (pop.contains(e.target)) {
        var so = e.target.closest('[data-sort]'); if (so) { S.sort = so.getAttribute('data-sort'); open = null; apply(); return; }
        var rs = e.target.closest('[data-reset]'); if (rs) { S[rs.getAttribute('data-reset')] = []; apply(); return; }
        if (e.target.closest('[data-done]')) { open = null; renderBar(); return; }
        var o = e.target.closest('[data-val]');
        if (o && open && open !== 'sort') { var set = S[open], val = o.getAttribute('data-val'), i = set.indexOf(val); if (i > -1) set.splice(i, 1); else set.push(val); apply(); }
      }
    });
    scrim.addEventListener('click', function () { open = null; renderBar(); });
    // an element detached by our own re-render is not an outside click
    document.addEventListener('click', function (e) { if (open && e.target.isConnected && !e.target.closest('[data-facet-pop],[data-facet]') && root.contains(bar)) { open = null; renderBar(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) { open = null; renderBar(); } });
    window.addEventListener('resize', function () { placeInk(); placePop(); });
    window.addEventListener('scroll', function () { if (open && window.innerWidth >= 700) placePop(); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeInk);

    apply();
  }

  Odds.initFacets = init;
  function boot() { $$('[data-facet-root]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
